import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=39dc9939&scoped=true&lang=pug&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dc9939",
  null
  
)

export default component.exports